// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"NewCalendarButton_linkButton__2c6wt","buttonWrapper":"NewCalendarButton_buttonWrapper__3iRkE"};